import axios from '@/axios'
const BASE_URL = '/api'
const api = {
  list: `${BASE_URL}/v3/material/`,
  type_list: `${BASE_URL}/v3/materialcategorys/`,
  dels: `${BASE_URL}/v3/material/deletes/`,
  setcategory: `${BASE_URL}/v3/material/setcategory/`,
}

export const MaterialDepositoryService = {
  getList(data) {
    return axios.get(api.list, { params: {...data, type: 'image'} }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  add(data) {
    return axios.post(api.list, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  edit(data) {
    return axios.put(`${api.list}${data.id}/`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  del(data) {
    return axios.delete(`${api.list}${data.id}/`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  getTypeList(data) {
    return axios.get(api.type_list, { params: data }).then(res => {
      return Promise.resolve(res.data)
    })
  },
  addType(data) {
    return axios.post(api.type_list, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  delType(data) {
    return axios.delete(`${api.type_list}${data.id}/`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  editType(data) {
    return axios.put(`${api.type_list}${data.id}/`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  dels(data) {
    return axios.put(`${api.dels}`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
  setcategory(data) {
    return axios.put(`${api.setcategory}`, data).then(res => {
      return Promise.resolve(res.data)
    })
  },
}
export default MaterialDepositoryService